import { ITaskRuleInput } from '@common/interfaces/taskRule'
import Base from './base'

/** A project's rules when `projectId` is given, otherwise the caller's own My Tasks rules. */
export default class TaskRules extends Base {
  list(projectId: string | null) {
    return this.apiClient.get(projectId ? `/task-projects/${projectId}/rules` : '/my-tasks/rules')
  }

  create(projectId: string | null, data: ITaskRuleInput) {
    return this.apiClient.post(
      projectId ? `/task-projects/${projectId}/rules` : '/my-tasks/rules',
      data,
    )
  }

  update(id: string, data: Partial<ITaskRuleInput>) {
    return this.apiClient.put(`/task-rules/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/task-rules/${id}`)
  }
}
